// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"DXapOMrK7ncDhfUhFJuJU","spaceLeft":"_2MzlGd0QXU6lJkwSYZbvsw","spaceBoth":"_3taUaPhhf1On-ydNiisqf8","spaceRight":"_2ioEf6FpoArjvkrQveCp_Z","inputGroup":"_29GVBSSmYUCFC5g6l937dR","input":"_1Zxqu2zZCLXygAxEwMNtW4","errorMessage":"_2Ks1ZnpBruMKL9exMv2W2H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TokenAmountInput.scss
// module id = 1283
// module chunks = 0